import React from 'react';
import PropTypes from 'prop-types';

export default function SvgAnimation(props) {
  return (
    <React.Fragment>
      {props.images && props.selectedImageIndex >= 0 && (
        <img
          src={props.images[props.selectedImageIndex].image}
          alt="animation"
          style={{
            width: props.images[props.selectedImageIndex].width
              ? `${props.images[props.selectedImageIndex].width}px`
              : 'auto',
            height: props.images[props.selectedImageIndex].height
              ? `${props.images[props.selectedImageIndex].height}px`
              : 'auto',
          }}
        />
      )}
    </React.Fragment>
  );
}

SvgAnimation.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      height: PropTypes.number,
    })
  ),
  selectedImageIndex: PropTypes.number,
};
